export const MS_GRAPH_ERROR_MESSAGES: Record<string, string> = {
  invalid_state: "The OAuth state parameter was invalid. Please try again.",
  expired_state: "The login session has expired. Please try again.",
  replayed_state: "The login request was already used. Please try again.",
  exchange_failed: "Microsoft token exchange failed. Please try again.",
  ms_error: "Microsoft returned an error. Please try again.",
};

/** sessionStorage key used to restore the page the user was on before
 *  being redirected to Microsoft for login / logout. */
export const MS_GRAPH_RETURN_URL_KEY = "ms_graph_return_url";

/**
 * sessionStorage key set by AppRedirectComponent when the user has just
 * completed a successful MS Graph OAuth flow from a user-profile page
 * (/user/:id).  UserFormEmailComponent checks this flag on init and, if the
 * user's mail-integration is still disabled, silently enables it and saves.
 */
export const MS_GRAPH_AUTO_ENABLE_KEY = "ms_graph_auto_enable_integration";
